export default {
    init() {
        let text_areas = document.getElementsByTagName('textarea');
        if(text_areas.length > 0) {
            // console.log("text areas exist")
            for(let i = 0; i < text_areas.length; i++) {
                let text_area = text_areas[i];

                if(text_area.innerHTML !== '') {
                    let label = text_area.previousElementSibling;
                    label.style.display = "none";    
                }

                if(text_area.previousElementSibling.classList.contains('text-area-text')) {
                    text_area.previousElementSibling.addEventListener('click', (e) => {
                        // console.log("focusing on textarea");
                        text_area.focus();
                        text_area.select();
                    })
                }

                text_area.addEventListener('input', function(e) {
                    // console.log("Text area is being changed :)");
                    if(this.previousElementSibling.classList.contains('text-area-text')) {
                        let label = this.previousElementSibling;

                        if(e.target.value !== "") {
                            label.style.display = "none";    
                        } else {
                            label.style.display = "block";
                        }
                    }
                    
                });
            }
        }
    }
}